import "./libs/css/bootstrap.min.css";
import "./libs/css/bootstrap-select.min.css";
import "./libs/css/line-awesome.css";
// import './libs/css/owl.carousel.min.css'
// import './libs/css/owl.theme.default.min.css'
import "./libs/css/jquery.fancybox.min.css";
import "./libs/css/daterangepicker.css";
import "./libs/css/animate.min.css";
import "./libs/css/animated-headline.css";
import { connect, useSelector, useDispatch } from "react-redux";

// import './libs/css/jquery-ui.css'
// import './libs/css/flag-icon.min.css'
import "./libs/css/style.css";
import Header from "./components/templates/Header";
import {
  Switch,
  Route,
  withRouter,
  Redirect,
  useHistory,
} from "react-router-dom";
import Home from "./pages/Home";
import Template from "./pages/Template";
import { useEffect, useState } from "react";
import {
  get_airlines,
  get_all_airports,
  get_flight_tokenId,
  get_session_user_id,
} from "./components/server/api";

import {
  setAirlines,
  setAirportList,
  setCalenderFare,
  setFlightToken,
  setSearchFlights,
  setUserId,
} from "./redux/global/global.action";
import Loader from "./components/loader/Loader";
import FlightDetails from "./pages/FlightDetails";
import FlightBooking from "./pages/FlightBooking";
import FlightSearch from "./components/Flight/FlightSearch";
import ReturnFlight from "./components/Flight/ReturnFlight";
import MultiStopFlight from "./components/Flight/MultiStopFlight";
import Filter from "./components/Flight/Filters";
import PassengerDetails from "./components/Flight/PassengersDetails";
import ReviewBooking from "./components/Flight/ReviewBooking";
import ReturnFlightResult from "./components/Return/ReturnFlightResult";
import ReturnFilter from "./components/Return/ReturnFilter";
import ReturnPassangerDetails from "./components/Return/ReturnPassengerDetails";
import ReturnReviewBooking from "./components/Return/ReturnReviewBooking";
import FlightSearchTemplate from "./pages/FlightSearchTemplate";
import FlightList from "./pages/FlightList";
import FlDetails from "./pages/FlDetails";
import AddPassenger from "./pages/AddPassenger";
import RoundFlDetails from "./components/Return/RoundFlDetails";
import RoundFlight from "./pages/RoundFlight";

const moment = require("moment");

function App() {
  const user_id = useSelector((state) => state.global.user_id);
  const airlines = useSelector((state) => state.global.airlines);
  const airport_list = useSelector((state) => state.global.airport_list);

  const dispatch = useDispatch();
  const [can_move, setCanMove] = useState(0);

  const flight_token_update = async () => {
    const checktoken = localStorage.getItem("flight_token");

    var get_calender_fare =  localStorage.getItem('SET_CALENDER_FARE')
    var get_search_flight = localStorage.getItem('SET_SEARCH_FLIGHTS')
    if(get_calender_fare){
      get_calender_fare  = JSON.parse(get_calender_fare)
      dispatch(setCalenderFare(get_calender_fare))
    }

    if(get_search_flight){
      get_search_flight = JSON.parse(get_search_flight)
      dispatch(setSearchFlights(get_search_flight))
    }
    if (user_id == 0) {
      const userid = await get_session_user_id();
      dispatch(setUserId(userid));
    }
    if (airlines.length === 0) {
      get_airlines().then((ar) => {
        if (ar.status) {
          dispatch(setAirlines(ar.data));
        }
      });
    }


    if (airport_list.length === 0) {
      get_all_airports().then((ar) => {
        if (ar.status) {
          dispatch(setAirportList(ar.data));
        }
      });
    }

    if (!checktoken) {
      get_flight_tokenId().then((resp) => {
        if (resp.status) {
          const strobj = {
            start_timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            end_timestamp: moment()
              .add(23, "hours")
              .format("YYYY-MM-DD HH:mm:ss"),
            TokenId: resp.TokenId,
          };
          dispatch(setFlightToken(strobj));
          localStorage.setItem("flight_token", JSON.stringify(strobj));
          setCanMove(1);
        }
      });
    } else {
      const tokndata = JSON.parse(checktoken);
      const start_time = moment(
        moment(tokndata.start_timestamp).format("YYYY-MM-DD")
      );
      const end_time = moment(tokndata.end_timestamp);
      const current_time = moment(moment().format("YYYY-MM-DD"));
      // if (current_time.isSame(start_time, end_time)) {
      if (current_time.isSame(start_time)) {
        dispatch(setFlightToken(tokndata));
        setCanMove(1);
      } else {
        get_flight_tokenId().then((resp) => {
          if (resp.status) {
            const strobj = {
              start_timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
              end_timestamp: moment()
                .add(23, "hours")
                .format("YYYY-MM-DD HH:mm:ss"),
              TokenId: resp.TokenId,
            };
            dispatch(setFlightToken(strobj));
            localStorage.setItem("flight_token", JSON.stringify(strobj));
            setCanMove(1);
          }
        });
      }
    }


  };

  useEffect(() => {
    flight_token_update();
  }, []);

  const homecomponent2 = <Template component={<Home />} />;
  // const flightcomponent = <Template component={<FlightDetails />} />;
  // const flightBookingComponent = <Template component={<FlightBooking />} />;


  
  const homecomponent = <FlightSearchTemplate />;
  const flightListcomponent = <FlightList />;
  const flightDetailcomponent = <FlDetails />;
  const flightDetailcomponent2 = <RoundFlight />;
  const addPassengerDetails = <AddPassenger />;
  const flightcomponent = <Template component={<FlightDetails />} />;
  const flightBookingComponent = <Template component={<FlightBooking />} />;

  // return  <ReturnReviewBooking />;
  // return <PassengerDetails />

  return (
    <>
      {!can_move ? (
        <Loader />
      ) : (
        <Switch>
          <Route exact path="/" render={() => homecomponent} />
          <Route exact path="/2" render={() => homecomponent2} />
          <Route exact path="/flight-list" render={() => flightListcomponent} />
          <Route exact path="/add-passenger/:TokenId/:TraceId/:ResultIndex" render={() => addPassengerDetails} />
          <Route exact path="/flight-details/:TokenId/:TraceId/:ResultIndex" render={() => flightDetailcomponent} />

          <Route exact path="/round-flight-details/:TokenId/:TraceId/:ResultIndex/:ResultIndex2" render={() => flightDetailcomponent2} />

          {/* <Route exact path="/" render={() => homecomponent} />
          <Route
            exact
            path="/flight-details/:TokenId/:TraceId/:ResultIndex"
            render={() => flightcomponent}
          />
          <Route
            exact
            path="/book-flight/:TokenId/:TraceId/:ResultIndex"
            render={() => flightBookingComponent}
          /> */}
        </Switch>
      )}
      {/* <ReturnFlightResult /> */}
      {/* <FlightSearch />
      <ReturnFlight />
      <MultiStopFlight />
      <Filter />
      <PassengerDetails /> */}
      {/* <ReviewBooking /> */}
      {/* <ReturnFlightResult /> */}
      {/* <ReturnPassangerDetails /> */}
      {/* <ReturnReviewBooking /> */}
      {/* <FlightSearch /> */}
    </>
  );
}

export default App;
